/**
 * Analytics ve roadmap görünümlerinde gösterilecek minimum uygulama sürümü (x.y.z).
 * Sürüm dışı tanımlayıcılar (ör. paket adı) etkilenmez; yalnızca anlamsal sürüm dizgileri filtrelenir.
 */
export const MIN_DISPLAY_APP_SEMVER = '3.0.0';

function compareSemverParts(a: string, b: string): number {
  const parse = (v: string): number[] => v.split('.').map((n) => parseInt(n, 10) || 0);
  const aParts = parse(a);
  const bParts = parse(b);
  const max = Math.max(aParts.length, bParts.length);
  for (let i = 0; i < max; i++) {
    const av = aParts[i] || 0;
    const bv = bParts[i] || 0;
    if (av !== bv) return av - bv;
  }
  return 0;
}

/** İki noktalı sürümü karşılaştırır (a, b'den büyükse pozitif). */
export function compareSemver(a: string, b: string): number {
  return compareSemverParts(a, b);
}

const DIGITS_PART = /^\d+$/;

/** "5.0.9" veya "v5.0.10" gibi noktalı sayısal sürüm mü? */
export function isSemanticVersionString(s: string): boolean {
  const t = (s ?? '').trim();
  if (!t) return false;
  const noV = t.replace(/^v/i, '');
  if (!noV.length) return false;
  const parts = noV.split('.');
  return parts.length > 0 && parts.every((p) => DIGITS_PART.test(p));
}

/**
 * app_id / app_version alanı analytics satırında: anlamsal sürüm ise MIN ve üzeri; değilse (paket id vb.) geçirilir.
 * Özel "app_id" kovası her zaman gizlenir.
 */
export function isDisplayableAppMetricVersion(appIdOrVersion: string): boolean {
  const t = (appIdOrVersion ?? '').trim();
  if (!t) return false;
  if (t === 'app_id') return false;
  if (!isSemanticVersionString(t)) return true;
  const v = t.replace(/^v/i, '');
  return compareSemverParts(v, MIN_DISPLAY_APP_SEMVER) >= 0;
}

/** Roadmap / Firestore: yalnızca geçerli anlamsal sürüm ve MIN_DISPLAY_APP_SEMVER ve üzeri. */
export function isDisplayableRoadmapAppVersion(version: string | null | undefined): boolean {
  const t = (version ?? '').trim();
  if (!t) return false;
  if (!isSemanticVersionString(t)) return false;
  const v = t.replace(/^v/i, '');
  return compareSemverParts(v, MIN_DISPLAY_APP_SEMVER) >= 0;
}
